import React from 'react';
import NotFound from '../../not_found';
import ChangeLanguage from '../../change_language';
import PushNotification from '../../push_notifcation';
import GeneralError from '../../general_error';
import SmartBanner from '../../shared/smart_banner';
import AutoRedeemPromoCode from '../../auto_redeem_promo_code';

function Overlays() {
  return (
    <>
      <NotFound />
      <ChangeLanguage />
      <PushNotification />
      <GeneralError />
      <SmartBanner />
      <AutoRedeemPromoCode />
    </>
  );
}

export default Overlays;
